import Vue from "vue";
import Vuex from "vuex";
Vue.use(Vuex);

const store = new Vuex.Store({
  state: {
    careSn: "",
    //操作者是不是主聯，在客戶畫像載入的時候設定這個store。
    operatorIsMainContact: false,
    //新增一個flag來記錄按下後續追蹤送出按鈕，用來啟動切換分頁到追蹤明細頁
    flag: 0,
  },
  getters: {},
  actions: {
    setCareSn: function (context, careSn) {
      context.commit("set_CareSn", careSn);
    },
    setOperatorIsMainContact: function (context, operatorIsMainContact) {
      context.commit("set_OperatorIsMainContact", operatorIsMainContact);
    },
    switchToListPage: function (context) {
      context.commit("switch_ToListPage");
    }
  },
  mutations: {
    set_CareSn: function (state, careSn) {
      state.careSn = careSn;
    },
    set_OperatorIsMainContact: function (state, operatorIsMainContact) {
      state.operatorIsMainContact = operatorIsMainContact;
    },
    switch_ToListPage: function (state) {
      state.flag = state.flag + 1;
    }
  }
});

export default store;



// WEBPACK FOOTER //
// ./src/vuex/store_tackingLead.js